import { type BrandLogo, brandLogos } from '~/lib/brand-logos';
import type {
  LogoBrand as LogoBrandCl,
  BrandWithLogo as BrandWithLogoCl,
} from '@i22team/td-longtail-vue-components';

export type LogoBrand = LogoBrandCl;
export type BrandWithLogo = BrandWithLogoCl;

const findBrand = (slug: string): BrandLogo | undefined => brandLogos[slug];

export function getBrandLogo(slug: string, color: boolean | undefined = undefined) {
  const brandLogo = findBrand(slug);
  if (!brandLogo) return undefined;
  if (color && brandLogo.logoColor) return brandLogo.logoColor;
  return brandLogo.logoBw || brandLogo.logoColor;
}

export function addLogo(brand: LogoBrand, color: boolean = false): BrandWithLogo {
  const brandLogo = findBrand(brand.slug);
  return {
    ...brand,
    logo: getBrandLogo(brand.slug, color),
    aspectRatio: brandLogo?.aspectRatio,
  };
}

export function getBrand(offer: ListOffer | Offer | undefined): undefined | BrandWithLogo {
  if (!offer?.product) return undefined;

  if (!offer?.product?.bundle) {
    // @ts-expect-error
    return addLogo(offer?.product?.family?.brand || {}) || undefined;
  }
  const bundledProducts =
    'bundledProducts' in offer.product ? offer.product.bundledProducts || [] : [];
  // @ts-expect-error
  const mainBrand = bundledProducts.length > 0 ? bundledProducts[0]?.family?.brand : undefined;
  // @ts-expect-error
  if (mainBrand && bundledProducts.every(({ family }) => family?.brand?.slug === mainBrand.slug)) {
    return addLogo(mainBrand);
  }

  return undefined;
}
